export const resize = () => {
  document.querySelector(':root').style.setProperty('--vh', window.innerHeight + 'px');
};
